import { useFormik } from 'formik';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';
import { v4 as uuidv4 } from 'uuid';

export const useFormikEnterPassword = (makeRequest: any) => {
  const intl = useIntl();

  return useFormik({
    initialValues: {
      email: '',
      password: '',
      applicationDeviceId: '3cdd5096-89fe-4f8e-b1b5-748c5b357400', 
      devicePlatform: 'browser',
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email(
        intl.formatMessage({ id: 'AUTH.VALIDATION.INVALID_EMAIL' })
      ).required(
        intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })
      ),
      password: Yup.string().required(
        intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })
      ),
    }),
    onSubmit: (submitValues) => {
      makeRequest(submitValues);
    },
  });
};
